import React from 'react';

const PackageCard = ({
  title = '',
  subtitle = '',
  style = {},
  onClick = () => {},
  children,
}) => {
  return (
    <div
      className={'package-card'}
      style={style}
      onClick={onClick}
    >
      {children ? (
        children
      ) : (
        <>
          <p className='package-title mb-0'>{title}</p>
          <p className='package-subtitle mb-0'>{subtitle}</p>
        </>
      )}
    </div>
  );
};

export default PackageCard;
